import truncateText from '@qonto/ui-kit/helpers/truncate-text';

export default truncateText;
